import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	rotationsTitle: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.list-rotation.rotation-list.rotations-title',
		defaultMessage: 'Rotations',
		description: 'Title for rotations configurable list.',
	},
	addRotation: {
		id: 'eoc-schedule.ui.list.edit-schedule.sidebar.list-rotation.rotation-list.add-rotation',
		defaultMessage: 'Add rotation',
		description: 'Button for adding rotation.',
	},
});
